import { IApplicationState } from '../../types/redux';

export function getOpenedPhones(state: IApplicationState) {
  return state.openedPhones;
}
